import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import searchIcon from 'images/search_icon.svg';

import { search_page_path } from '../../../routes';

export default function SearchBar({
  isSearchLandingPage,
  scope,
}: {
  isSearchLandingPage: boolean;
  scope: string;
}) {
  const [query, setQuery] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>();

  const handleChange = (e) => setQuery(e.target.value);

  return (
    <div
      className={clsx('mt-20 md:mt-40', {
        'px-16': isSearchLandingPage,
      })}
    >
      <div
        className={clsx({
          'max-w-[600px] mx-auto': isSearchLandingPage,
        })}
      >
        <form id="form_id" action={search_page_path()} method="get" data-id="search-form">
          <div className="flex flex-col gap-16">
            <div className="flex items-center gap-12">
              <img src={searchIcon} width="24" height="24" alt="" />
              <div>
                <h1 className="text-headline-xs font-bold leading-none m-0 p-0">
                  Search The Information
                </h1>
                <p className="text-caption italic m-0">Powered by AI</p>
              </div>
            </div>
            <textarea
              name="query"
              className={clsx(
                // add min-width and max-width classes to prevent horizontal resizing of textarea
                'w-full min-w-full max-w-full min-h-[100px] px-16 py-10 rounded-2',
                'text-body-sm text-grayscale-50 border-gray-300'
              )}
              value={query}
              onChange={handleChange}
              ref={textAreaRef}
            />
            <button
              type="submit"
              className={clsx(
                'text-button-md font-sans !text-white bg-primary-red uppercase border-none',
                'xs:w-[200px] h-40 flex items-center justify-center self-end rounded-2',
                'hover:bg-pro-red focus:bg-pro-red transition-colors'
              )}
            >
              Search
            </button>
          </div>
          <input type="hidden" name="scope" value={scope} />
        </form>
      </div>
    </div>
  );
}
